import React, { useMemo, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

// decode looper sample data.
function decodeV3(cnt, byte0, byte1, byte2, byte3, debug = false) {
  let original = `${byte0.toString(16).padStart(2,'0')} ${byte1.toString(16).padStart(2,'0')}  ${byte2.toString(16).padStart(2,'0')} ${byte3.toString(16).padStart(2,'0')}`
        
    let decodedValue = (byte3 << 24) | (byte2 << 16) | (byte1<<8) | byte0;
    original += ` : ${decodedValue.toString(16).padStart(8,'0')}`

    let negative=false;

    // check sign and invert if negative
    if (decodedValue & 0x80000000) {
      decodedValue =  (decodedValue & 0x7fffffff)
      negative=true;
    }
           
    original += ` ! ${decodedValue.toString(16).padStart(8,'0')} ${decodedValue.toString(2).length} bits! `

     if ( decodedValue >= 0x20000000 ) {
       decodedValue = decodedValue - 0x22000000;    // rebase
       decodedValue = decodedValue * 16;          // 16x scale .. dont use shift in JS as it will convert signed and bugger up the result
       decodedValue = decodedValue + 0x20000000;   // rebase  
     }
       
    if (negative)
      decodedValue = -decodedValue

    if (debug) {
      console.log( `${cnt} : ${original} : ${decodedValue}`);
    }
    return Number(decodedValue);
}

function xorTransform(data, key) {
    const k = key.length;
    const out = new Array(data.length);

    for (let i = 0; i < data.length; i++) {
        out[i] = data[i] ^ key[i % k];
    }

    return out; // regular JS array
}

const padSampleKey = [
  0x06, 0x00, 0x00, 0x00, 0x1a, 0x00, 0x10, 0x00, 0x02, 0x00,
  0x08, 0x00, 0x02, 0x00, 0x16, 0x00, 0x00, 0x00, 0x00, 0x00
]

const HexFloatPlotter = () => {
  const defaultHexString = `00 00 00 00 90 93 D4 0C C0 3F 9C 19 A0 A2 64 22 1C 19 2D 23 D8 5D F2 23 68 AA B3 24 60 3C 70 25 20 56 27 26 88 3F D8 26 98 46 82 27 60 C0 24 28 60 09 BF 28 90 86 50 29 80 A5 D8 29 50 DD 56 2A 20 AF CA 2A 50 A6 33 2B 70 59 91 2B 40 6A E3 2B 20 86 29 2C A0 66 63 2C 80 D1 90 2C 20 99 B1 2C 80 9C C5 2C 80 C7 CC 2C E0 12 C7 2C 70 84 B4 2C C0 2E 95 2C 70 31 69 2C C0 B8 30 2C 60 FD EB 2B 70 44 9B 2B 40 DF 3E 2B B0 2A D7 2A F0 8E 64 2A 70 7F E7 29 E0 79 60 29 00 06 D0 28 40 B5 36 28 A8 21 95 27 C8 ED EB 26 D8 C3 3B 26 F8 54 85 25 A0 58 C9 24 F0 8B 08 24 C0 B0 43 23 18 8D 7B 22 C0 A3 0E 1B 90 3F 49 0E 1E 7D 75 01 F0 BC 5F 8B 80 86 29 98 30 B0 4D A2 E8 76 16 A3 A0 22 DC A3 88 EC 9D A4 B8 11 5B A5 F8 D3 12 A6 78 7A C4 A6 90 52 6F A7 60 B0 12 A8 B0 EF AD A8 40 74 40 A9 D0 AA C9 A9 50 09 49 AA B0 0F BE AA 30 48 28 AB 00 48 87 AB 90 AF DA AB 10 2B 22 AC 90 72 5D AC 80 4A 8C AC A0 83 AE AC A0 FB C3 AC F0 9C CC AC C0 5E C8 AC 70 45 B7 AC 30 62 99 AC 00 D3 6E AC C0 C2 37 AC D0 68 F4 AB E0 08 A5 AB D0 F2 49 AB 30 82 E3 AA 00 1E 72 AA 70 38 F6 A9 00 4E 70 A9 60 E5 E0 A8 C0 8E 48 A8 78 E3 A7 A7 08 85 FF A6 D0 1C 50 A6 28 5B 9A A5 F0 F6 DE A4 A0 AC 1E A4 8C 3D 5A A3 50 6F 92 A2 C0 AD 80 9C 00 BC BD 8F 64 F5 EA 82 70 C0 EA 09 00 7D B6 16 1C B6 36 22 70 CA FF 22 90 DA C5 23 48 1F 88 24 40 D5 45 25 A0 3D FE 25 F0 9E B0 26 D0 45 5C 27 A0 85 00 28 20 B9 9C 28 40 43 30 29 90 8F BA 29 20 13 3B 2A 80 4C B1 2A E0 C4 1C 2B 30 10 7D 2B 80 CD D1 2B B0 A7 1A 2C 70 55 57 2C B0 99 87 2C F0 43 AB 2C 50 30 C2 2C C0 47 CC 2C 20 80 C9 2C 30 DC B9 2C B0 6B 9D 2C 40 4B 74 2C 30 A4 3E 2C 80 AC FC 2B 90 A6 AE 2B C0 E0 54 2B 70 B5 EF 2A 60 8A 7F 2A 50 D0 04 2A B0 02 80 29 20 A7 F1 28 D0 4C 5A 28 D8 8B BA 27 08 05 13 27 C8 60 64 26 C0 4E AF 25 10 85 F4 24 98 BF 34 24 2C BF 70 23 F8 48 A9 22 00 59 F2 1D 20 04 32 11 F8 63 60 04 00 A3 75 88 E0 27 43 95 A8 B4 1F A2 FC 13 E9 A2 F4 85 AF A3 00 43 72 A4 38 87 30 A5 50 93 E9 A5 28 AD 9C A6 98 20 49 A7 30 40 EE A7 E0 65 8B A8 A0 F3 1F A9 00 54 AB A9 E0 FA 2C AA C0 65 A4 AA A0 1C 11 AB 20 B2 72 AB 20 C4 C8 AB 10 FC 12 AC 40 0F 51 AC 40 BF 82 AC 20 DA A7 AC 90 3A C0 AC 10 C8 CB AC F0 76 CA AC A0 48 BC AC 40 4B A1 AC 00 9A 79 AC E0 5C 45 AC 50 C8 04 AC 60 1D B8 AB 10 A9 5F AB 60 C4 FB AA C0 D3 8C AA D0 46 13 AA D0 97 8F A9 30 4B 02 A9 00 EF 6B A8 88 1A CD A7 78 6D 26 A7 78 8F 78 A6 68 2F C4 A5 B8 02 0A A5 90 C4 4A A4 60 35 87 A3 C8 19 C0 A2 A0 A0 63 9F 00 13 A6 92 F8 C3 D5 85 70 69 00 07 20 8C CF 13 24 AC 08 22 D8 53 D2 22 18 25 99 23 E8 57 5C 24 F8 27 1B 25 60 D5 D4 25 60 A5 88 26 20 E3 35 27 60 E0 DB 27 40 F6 79 28 B0 85 0F 29`;
  const [hexString, setHexString] = useState(defaultHexString);
  const [maxSamples, setMaxSamples] = useState(1000);
  const [sampleFormat, setSampleFormat] = useState('looper');
  const [consoleDebugging, setConsoleDebugging] = useState(false);
  const [appliedHexString, setAppliedHexString] = useState(defaultHexString);
  const [appliedMaxSamples, setAppliedMaxSamples] = useState(1000);
  const [appliedSampleFormat, setAppliedSampleFormat] = useState('looper');
  const [appliedConsoleDebugging, setAppliedConsoleDebugging] = useState(false);
  
  const data = useMemo(() => {
    const bytes = appliedHexString.replace(/\s+/g, '').match(/.{2}/g)?.map(byte => parseInt(byte, 16)) || [];
    
    const values = [];
    const originals = [];
    let cnt=0;
    
    if (appliedSampleFormat === 'looper') {
      // Process in groups of 4 bytes
      for (let i = 0; i < bytes.length && i < appliedMaxSamples * 4; i += 4) {
        if (i + 3 >= bytes.length) break;
        
        const byte0 = bytes[i];
        const byte1 = bytes[i + 1];
        const byte2 = bytes[i + 2];
        const byte3 = bytes[i + 3];
        
        const decodedValue = decodeV3(cnt++,byte0,byte1,byte2,byte3, appliedConsoleDebugging);
        
        values.push(decodedValue);
      }
    } else {
      // Process in groups of 2 bytes
      const xorData = xorTransform(bytes, padSampleKey);  
      for (let i = 0; i < xorData.length && i < appliedMaxSamples * 2; i += 2) {
        if (i + 1 >= xorData.length) break;
        
        const byte0 = xorData[i];
        const byte1 = xorData[i + 1];
        
        let value = byte0 | (byte1 << 8);
        if (value & 0x8000) value = value - 0x10000;
        
        values.push(value);
      }
    }
    

    // Create chart data
    return values.map((value, index) => ({
      index: index,
      value: value
    }));
  }, [appliedHexString, appliedMaxSamples, appliedSampleFormat, appliedConsoleDebugging]);

  return (
    <div style={{ width: '100%', height: '100vh', padding: '8px', backgroundColor: '#f9fafb' }}>
      <div style={{ backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', padding: '8px', height: '100%', display: 'flex', flexDirection: 'column' }}>
        <h2 className="text-2xl font-bold mb-1 text-gray-800" style={{margin: '4px'}}>MC707/MC101 Sample Data Visualizer - Test your encoders!</h2>
        <div style={{ marginBottom: '16px' }}>
          <label htmlFor="hexInput" style={{ display: 'inline-block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
            Hex String:
          </label>
          <input
            id="hexInput"
            type="text"
            value={hexString}
            onChange={(e) => setHexString(e.target.value)}
            style={{
              width: '40rem',
              padding: '8px 12px',
              fontSize: '14px',
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              fontFamily: 'monospace',
              outline: 'none',
              transition: 'border-color 0.2s',
            }}
            onFocus={(e) => e.target.style.borderColor = '#2563eb'}
            onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
            placeholder="Enter hex string (e.g., 00 00 00 00 90 93...)"
          />
          <button
            onClick={() => {
              setAppliedHexString(hexString);
              setAppliedMaxSamples(maxSamples);
              setAppliedSampleFormat(sampleFormat);
              setAppliedConsoleDebugging(consoleDebugging);
            }}
            disabled={hexString === appliedHexString && maxSamples === appliedMaxSamples && sampleFormat === appliedSampleFormat && consoleDebugging === appliedConsoleDebugging}
            style={{
              marginLeft: '12px',
              padding: '8px 16px',
              fontSize: '14px',
              fontWeight: '500',
              color: 'white',
              backgroundColor: hexString === appliedHexString && maxSamples === appliedMaxSamples && sampleFormat === appliedSampleFormat && consoleDebugging === appliedConsoleDebugging ? '#9ca3af' : '#2563eb',
              border: 'none',
              borderRadius: '6px',
              cursor: hexString === appliedHexString && maxSamples === appliedMaxSamples && sampleFormat === appliedSampleFormat && consoleDebugging === appliedConsoleDebugging ? 'not-allowed' : 'pointer',
              transition: 'background-color 0.2s',
            }}
            onMouseEnter={(e) => {
              if (!(hexString === appliedHexString && maxSamples === appliedMaxSamples && sampleFormat === appliedSampleFormat && consoleDebugging === appliedConsoleDebugging)) {
                e.target.style.backgroundColor = '#1d4ed8';
              }
            }}
            onMouseLeave={(e) => {
              if (!(hexString === appliedHexString && maxSamples === appliedMaxSamples && sampleFormat === appliedSampleFormat && consoleDebugging === appliedConsoleDebugging)) {
                e.target.style.backgroundColor = '#2563eb';
              }
            }}
          >
            Update Graph
          </button>
          <label htmlFor="maxSamplesInput" style={{ display: 'inline-block', marginLeft: '16px', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
            Max Samples:
          </label>
          <input
            id="maxSamplesInput"
            type="number"
            value={maxSamples}
            onChange={(e) => setMaxSamples(parseInt(e.target.value) || 1000)}
            min="1"
            style={{
              width: '8rem',
              padding: '8px 12px',
              fontSize: '14px',
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              outline: 'none',
              transition: 'border-color 0.2s',
            }}
            onFocus={(e) => e.target.style.borderColor = '#2563eb'}
            onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
          />
        </div>
        <div style={{ marginBottom: '16px' }}>
          <span style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginRight: '12px' }}>
            Sample Format:
          </span>
          <label style={{ marginRight: '16px', fontSize: '14px', color: '#374151', cursor: 'pointer' }}>
            <input
              type="radio"
              name="sampleFormat"
              value="looper"
              checked={sampleFormat === 'looper'}
              onChange={(e) => setSampleFormat(e.target.value)}
              style={{ marginRight: '6px' }}
            />
            Looper Sample Format
          </label>
          <label style={{ fontSize: '14px', color: '#374151', cursor: 'pointer' }}>
            <input
              type="radio"
              name="sampleFormat"
              value="pad"
              checked={sampleFormat === 'pad'}
              onChange={(e) => setSampleFormat(e.target.value)}
              style={{ marginRight: '6px' }}
            />
            Pad Sample Format
          </label>
          <label style={{ marginLeft: '16px', fontSize: '14px', color: '#374151', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={consoleDebugging}
              onChange={(e) => setConsoleDebugging(e.target.checked)}
              style={{ marginRight: '6px' }}
            />
            Console Debugging
          </label>
        </div>
        <div className="text-sm text-gray-600 mb-4">
          Total data points: {data.length}
        </div>
        <div style={{ flex: 1, minHeight: 0 }}>
          <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis 
              dataKey="index" 
              label={{ value: 'Index', position: 'insideBottom', offset: -5 }}
            />
            <YAxis 
              label={{ value: 'Value', angle: -90, position: 'insideLeft' }}
            />
            <Tooltip 
              formatter={(value) => `${value} ${value.toString(16)}`}
              labelFormatter={(label) => `Index: ${label}`}
            />
            <Legend />
            <Line 
              type="monotone" 
              dataKey="value" 
              stroke="#2563eb" 
              dot={false}
              strokeWidth={2}
              name="Value"
            />
          </LineChart>
        </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default HexFloatPlotter;